import React from "react";
const badgeStyle = {
  position: "absolute",
  top: "-7px",
  right: "-7px",
  fontSize: "12px",
  height: "24px",
  width: "24px",
  background: "#EEEEEE",
  borderRadius: "50%",
  display: "flex",
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: "black",
  fontFamily: "Gilroy-Bold",
};

const FilterCountBadge = ({ count }) => {
  console.log(count, "count")
  if (count === 0) return <span></span>;
  return <span style={badgeStyle}>{count}</span>;
};

export default FilterCountBadge;
